import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

function PSNCopyButton() {
  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const generalDetails = useSelector((state) => state.psn.generalDetails);
  const soldToShipToDetails = useSelector((state) => state.psn.soldToShipToDetails);
  const priceBreakdownDetails = useSelector((state) => state.psn.priceBreakdownDetails);

  // Function to generate copy text
  const getCopyText = () => {
    const { JobNumber, ModelNumber, ProjectName } = generalDetails || {};
    const { ShipToCompanyName, ShipToAddress, ShipToAddress2, ShipToCity, ShipToState, ShipToZipCode, ShipToFirstName, ShipToLastName, ShipToPhone, ShipToMobilePhone, ShipToEmail } = soldToShipToDetails || {};
    const { FreightAmount, FreightPayTo, SetupAmount, SetupPayTo, StartAmount, StartPayTo, CraneAmount, CranePayTo, InspectionAmount, InspectionPayTo, OtherAmount, OtherPayTo } = priceBreakdownDetails || {};

    const formatCurrency = (amount) => {
      return `$${parseFloat(amount || 0).toFixed(2)}`;
    };

    // Start building the text by adding non-empty sections dynamically
    const lines = [];

    // General Info
    const generalInfo = `${JobNumber || ''} | ${ModelNumber || ''} | ${ProjectName || ''}`;
    if (generalInfo.trim()) {
      lines.push(generalInfo);
    }

    // Ship To Details
    const shipToInfo = [
      ShipToCompanyName || '',
      ShipToAddress || '',
      ShipToAddress2 || '',
      `${ShipToCity || ''}, ${ShipToState || ''} ${ShipToZipCode || ''}`.trim()
    ].filter(Boolean).join('\n');
    if (shipToInfo.trim()) {
      lines.push(`\nShip To:\n${shipToInfo}`);
    }

    // Ship To Contact
    const shipToContact = [
      `${ShipToFirstName || ''} ${ShipToLastName || ''}`.trim(),
      ShipToPhone ? `Phone: ${ShipToPhone}` : '',
      ShipToMobilePhone ? `Cell Phone: ${ShipToMobilePhone}` : '',
      ShipToEmail ? `Email: ${ShipToEmail}` : ''
    ].filter(Boolean).join('\n');
    if (shipToContact.trim()) {
      lines.push(`\nShip To Contact:\n${shipToContact}`);
    }

    // Price Breakdown
    const priceBreakdown = [
      `Freight: ${formatCurrency(FreightAmount)}${FreightPayTo ? ` - ${FreightPayTo}` : ''}`,
      `Setup: ${formatCurrency(SetupAmount)}${SetupPayTo ? ` - ${SetupPayTo}` : ''}`,
      `Startup: ${formatCurrency(StartAmount)}${StartPayTo ? ` - ${StartPayTo}` : ''}`,
      `Crane: ${formatCurrency(CraneAmount)}${CranePayTo ? ` - ${CranePayTo}` : ''}`,
      `Inspection: ${formatCurrency(InspectionAmount)}${InspectionPayTo ? ` - ${InspectionPayTo}` : ''}`,
      `Other: ${formatCurrency(OtherAmount)}${OtherPayTo ? ` - ${OtherPayTo}` : ''}`
    ].join('\n');
    
    lines.push(`\nPrice Breakdown:\n${priceBreakdown}`);

    return lines.join('\n').trim(); // Join all lines into the final formatted string
  };

  // Handle copy functionality
  const handleCopy = () => {
    const copyText = getCopyText();
    navigator.clipboard.writeText(copyText)
      .then(() => {
        alert("Details copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  return (
    <>
      <div className="row m-3">
        <div className="col d-flex justify-content-center">
          <Button onClick={() => setShowModal(true)}>
            PSN Copy
          </Button>
        </div>
      </div>

      {/* Modal to display the copy text */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Preview Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <pre>{getCopyText()}</pre> {/* Display the formatted text */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleCopy}>
            Copy to Clipboard
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PSNCopyButton;
